import { render } from "./TakeAPhoto.vue?vue&type=template&id=16ee481c"
import script from "./TakeAPhoto.vue?vue&type=script&lang=js"
export * from "./TakeAPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__